import { getFinancierGroup } from 'common/api/users';

import {
    FETCH_GROUPS,
    FETCH_GROUPS_FAILURE,
    FETCH_GROUPS_SUCCESS,
} from '../actionTypes';
import { companyUsersActions } from '../reducer';

export default (id) => (dispatch) => {
    dispatch(companyUsersActions[FETCH_GROUPS]());

    getFinancierGroup(id)
        .then((response) => {
            dispatch(
                companyUsersActions[FETCH_GROUPS_SUCCESS](response.data.data),
            );
        })
        .catch((error) =>
            dispatch(
                companyUsersActions[FETCH_GROUPS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
